import GraphikArabicMedium from 'assets/fonts/graphik-arabic-medium.woff2';
import GraphikArabicRegular from 'assets/fonts/graphik-arabic-regular.woff2';
import GraphikMedium from 'assets/fonts/graphik-medium.woff2';
import GraphikRegular from 'assets/fonts/graphik-regular.woff2';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
    v2.0 | 20110126
    License: none (public domain)
  */ 

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 16px;
    font: inherit;
    font-family: 'Inter', sans-serif !important;
   
  }

  /* setting font size to 10px for easier rem calculations */
  html { font-size: 100%; };

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .ant-typography strong {
    font-weight: 500;
  }

  .prflbx{
        img{
          max-width: 125px;
        }
  }
 
  @font-face {
    font-family: 'Graphik';
    font-weight: 400;
    src: url(${GraphikRegular}) format('woff2');
  }

  @font-face {
    font-family: 'Graphik';
    font-weight: 500;
    src: url(${GraphikMedium}) format('woff2');
  }

  @font-face {
    font-family: 'GraphikArabic';
    font-weight: 400;
    src: url(${GraphikArabicRegular}) format('woff2');
  }


  @font-face {
    font-family: 'GraphikArabic';
    font-weight: 500;
    src: url(${GraphikArabicMedium}) format('woff2');
  }




  .notificationCart{
      position: fixed; background: #fff; top: 70px; width: 330px; max-height:calc(100vh - 90px); overflow-y: auto; height: 100%; padding:20px; 
      z-index: 2;  
      .card{
          .head{
            margin-bottom:15px; 
            h3{font-size:16px;}            
          }
          height:100%;
          .nitybx{
          padding: 10px; border-radius: 5px; margin-left: -10px; margin-right: -10px;
          &:hover{background: #f7f7f7;}
          & + .nitybx{margin-top:5px;}
            .nblst{
              display:flex; 
              & + .nblst{margin-top:15px;}
              .nlicon{
                background: #E5ECF6; width: 30px; height: 30px; border-radius: 5px; display: flex; align-items: center; justify-content: center;
              }
              .nl_vlu{
              margin-left:10px; width: 77%;
                h3{ font-size: 14px; color: #1C1C1C; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 99%; font-weight: 500;}
                h6{font-size: 12px; color: #1C1C1C;}
                p{font-size:12px; color:#A2A2A2;}
              }
            }
          }
        }
    }
  

  .ant-picker-dropdown {
    .ant-picker-today-btn {
      color: ${({ theme }) => theme.colors.greenLight};

      &:hover {
        color: ${({ theme }) => theme.colors.greenDark};
      }
    }
  }


  .day_v_head .sc-kDvujY.kdHSeD {
    gap: 10px !important;

    // flex-wrap:wrap;
}
  .filter_day_v {
    // background: #fff; padding: 4px 6px; border-radius: 6px; border: 1px solid #00473A;

    .ant-select-selector {
      padding: 0px !important;

      .ant-select-selection-placeholder {
        padding-inline-end: 30px;
      }
    }
}

.custom-tabs{
  .ant-tabs-nav{
    .ant-tabs-nav-wrap{
      overflow: visible;
      .ant-tabs-nav-list{
        .ant-tabs-tab{
          .ant-tabs-tab-btn{
            .ant-scroll-number{ top: -10px; right: -10px;}
          }
        }
      }
    }
  }
}


.cstm_centermodal{
  .cnglist{
    padding:0px;
 


      .crd_rptr{
         padding:7px;
        .crd_bx{
          border: 1px solid #f0f0f0; padding: 10px; border-radius: 5px; display: flex;
          &:hover{ box-shadow:rgb(179 179 179 / 20%) 0px 4px 6px !important; border:1px solid #223666 !important;}
          .media{
            width: 55px; height: 55px; border-radius: 50%; overflow: hidden;
            display: flex; align-items: center; justify-content: center;
            svg{
              height: 50px; width: 50px; color: #233364; border: 1px solid #233364; padding: 10px; border-radius: 50%;
            }
            img{
                border-radius: 50%; display: block; object-fit: cover; height: 100%;
              }
            .ant-image {
              height:100%;
              img{
                border-radius: 50%; display: block; object-fit: cover; height: 100%;
              }
                .ant-image-mask{
                  .ant-image-mask-info{
                    font-size:0px;
                    svg{ height: 20px; width: 20px; }
                  }
                }
            }
            
          }
          .crd_vlu{
            padding-left: 15px; position:relative; width:calc(100% - 50px);
            h3{font-size: 16px; font-weight: 500; margin-bottom:0px}
            p{
              font-size: 13px; margin-bottom:0px; display: inline-block;             
            }          
            .button-group{
              position: absolute; right: 0px; top: 0px; bottom: 0px; margin: auto; display: flex; align-items: center;
              .btn{ font-size: 13px; padding: 3px 10px; display: block; }
            }
          }
        }
      } 
  }
}

.sidebarl{
  .ant-layout-sider{
    .ant-layout-sider-children{
      .ant-menu{
        padding: 10px 0px; gap:0px;
        li{
          padding: 5px 0px 5px 15px !important; height: auto;
          svg{color: #BEBEC3;}
          & + li{
            border-top: 1px solid #334373; margin-top: 5px;
          }
          .ant-menu-title-content{
            a{
              color: #BEBEC3;
              &.active{color:#fff; font-weight: 500;}
            }
          }
        }        
      }
    }
  }
}

 .uplddocbx{
    .ant-upload-list{
      .ant-upload-list-item-container{width:100% !important; height:auto !important;}
    }
  }


 .tmrbx{
  font-size:12px; display: flex; align-items: center;
  svg{height:15px;}
 }
.mediafolder{    
  width: 60px; height: 60px; display: flex; background: #fff; align-items: center; justify-content: center; border-radius:3px;
  
  .sbmltybx{
    display: flex; position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; background: #000000a3; border-radius: 5px;
    .ant-btn{
      .anticon{
        svg{
          width: 20px; height: 20px; color: #fff;
        }
      }
    }
  }

   &.meida{
              position:relative;            
              .mtlybtnbx{
                position: absolute; background: #00000073; left: 0px; right: 0px; top: 0px; bottom: 0px; border-radius: 5px;
                display: flex; align-items: center; justify-content: center;
                .ant-btn{
                  svg{height:20px; width:20px; color:#fff;}
                }
              }
            }
  a, button{
    display: flex; align-items: center; justify-content: center;
    svg{width:35px; height:35px; color:#223666;}
    &:hover{color:#223666;}
  }

            .ant-image-mask{
              .ant-image-mask-info{font-size:0px;
                svg{width:20px; height:20px; color: #fff;}
              }
            }
            .ant-image{
              width:100%; height:100%;
              img{
                width:100%; height:100%; object-fit: cover; border-radius: 5px;
              }
            }
}


 @media(max-width:900px){

 .custom-tabs .ant-tabs-nav .ant-tabs-nav-wrap{
     overflow: auto;
    padding-bottom: 12px;
    padding-top: 10px;
 }

  .global_slots{
    .slot_mbl{
      .halfHours{
        .sc-ckEbSK{
          display: flex; align-items: center;
          span.ant-typography{
            display:none;
          }
          .sc-GhhNo{
            width: 100%;
            span{
              display:inline-block;
            }
          }
        }
      }
    }
  }
}
  .sidebarl{
  .ant-layout-sider{
    .ant-layout-sider-children{
      .ant-menu{
        padding-bottom: 25px;

      }
    }
  }
} 
  .active-menu {
  font-weight: bold;
  color: #1890ff; /* Example active color */
}


.upld_item{
  background: #F5F6FA; padding: 20px 0; border-radius: 8px;

  &.mltybs{
    .ant-upload-wrapper{
      display: flex; justify-content: center; align-items: center; width:100%;

      .ant-upload-list{
        width: 100%; align-items: center; display: flex; justify-content: flex-start; padding: 5px 15px; flex-wrap: wrap;
        
        .ant-upload-list-item-container{
          margin: 0px !important; width: 73px !important; padding: 5px; height: 73px !important;
          .ant-upload-list-item { 
            border-color: #233364; 
            .ant-upload-list-item-name{color:#223666; font-size:10px;     bottom: 0px;}
            .ant-upload-list-item-thumbnail{
            
              svg{
                fill:#223666;
                path{
                  &:last-child{fill:#223666;}
                }
              }
            }
          }
        }

        .ant-upload{
          width: 100%; background: none; border: none; margin:0; height: 100%; margin-top:15px;
          .upld_img{
            img{margin: auto;}
            .drp_text{color: #7E84A3;font-size: 15px;display: block;font-weight: 600; margin-top: 15px;
            span{display: block;}
            a{color: #223666;font-weight: 400;text-decoration: underline;}
            }
          }
        }
      }
    }
  }

  .ant-upload-wrapper{
    display: flex; justify-content: center; align-items: center; width:100%;
    .ant-upload-list{
      width: 100%; align-items: center; display: flex; justify-content: center !important; padding: 5px 15px; flex-wrap: wrap;      
      .ant-upload-list-item-container{
        margin: 0px !important; width: 110px !important; padding: 5px; height: 110px !important;
        .ant-upload-list-item { border-color: #233364; }
      }
      .ant-upload{
        width: 100%; background: none; border: none; margin:0; height: 100%; margin-top:15px;
        .upld_img{
          img{margin: auto;}
          .drp_text{color: #7E84A3;font-size: 15px;display: block;font-weight: 600; margin-top: 15px;
          span{display: block;}
          a{color: #223666;font-weight: 400;text-decoration: underline;}
          }
        }
      }
    }
  }
}

.ctgrybx{
      h4{
        font-size:16px; color:#313030; text-decoration: underline;
      }
        ul{
          list-style: none; display: flex; margin:-2px 0px 7px 0px; padding: 0px;
          li{
            color:#20356A; font-size:16px; margin: 0px; padding: 0px; position:relative;
            a{
              font-size:16px; color:#313030; text-decoration: underline; font-weight: 500;
            }
              & + li{
                margin-left:10px; padding-left:15px;
                &:after{
                  content:'>'; position: absolute; left: 0px;
                  }
              }

          }
        }
    }
.crdsubhed{
    margin-bottom:10px; align-items: center;
    h3{
      margin-bottom: 0px; font-size: 20px; font-weight: 600; color: #20356A; display:flex;
      .btn{ background: #F3F9EE; color: #7BA76C; font-size: 12px; font-weight: 500; padding: 4px 8px; margin-left: 15px; display: block; }
      }
    .ant-btn-group{
      .btn{}
    }
}

.btn-primary { color: #fff; border: none; font-weight: 500; border-radius: 3px; background: linear-gradient(to right, #20356A, #445FA1); }
.btn { padding: 8px 14px; height: auto; }
.ant-btn { box-shadow: none; height: auto; padding: 5px 10px; border-radius: 5px; }

.spnldrbx{
  position: fixed; z-index: 2; left: 0px; right: 0px; top: 0px; bottom: 0px; margin: auto; display: flex; align-items: center; justify-content: center; background: #0000003d;
}


.legl_tab{margin-top: -10px}
.lgl_crd .ant-card-body{padding: 15px}

.src_flter{
  input { width: 190px; margin-right: 10px; }
}

.dsbbuttongrp{
  display:flex; align-items: center; justify-content: space-between;
  .errrbx{
    h4{font-size: 14px; margin: 0px; color: #EC4E6E;}    
  }
  .butnbx{
    .btn{
      padding: 4px 12px; font-size: 12px; font-weight: 500; color: #fff; border-radius: 25px; border: none; background: linear-gradient(to right, #20356A, #445FA1);
    }  
  }
}
 
.list_cstm{
  ul{
    li{padding: 10px 0 !important;}
  }
}

@media(max-width:980px){

  .app-header{
    .drpmenu{
      .ant-space{
        .ant-space-item{
          .ant-btn{
            display: flex; padding: 0px;
            .ant-space{width:auto;}
          }
        }
      }      
    }    
    .header_title_top{
      display: flex; flex-direction: row-reverse;
      .ant-space-item{
        .w-48{width: 9rem;}
        & + .ant-space-item{
          width:35px;
          svg{margin:0px;}
        }
      }
    }
  }
 .upld_docs .ant-tooltip{
display:none;
position:relative
}
  .otpbx {
    .ant-card{
      .ant-card-body{
        padding:0px;
        .ant-row{
          .ant-col{
            .ant-form {
              .ant-row{                
                .ant-col{
                  padding:0px !important;
                  & + .ant-col{padding-left:10px !important;}                  
                }
              }
            }
          }
        }
      }
    }
  }

}
.updcbx{
  display:flex; alignItems:center; position: relative;
  .eyeiconi{
    position: absolute; left: 8px; z-index: 13; font-size: 18px; top: 7px;
  }
  .ant-upload-wrapper{
    
    .ant-upload-list-item-container{
      .ant-upload-list-item{
      background-color:transparent;
        .ant-upload-list-item-actions{
          top: 5px; display: flex; align-items: center; justify-content: end; padding-right: 5px;
          a{display:none;}
          button.ant-btn{
            svg{color:#E04343;}            
          }
        }
      }
    }
  }
}


.sign_up {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    gap: 5px;
}

.sign_up a {
    color: #223666;
    text-decoration: underline;
    font-weight: 500;
}


.sign_up_card {
max-height: calc(100vh - 120px);
overflow:auto;
height: auto;
}

/* width */
.sign_up_card::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.sign_up_card::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.sign_up_card::-webkit-scrollbar-thumb {
  background: #21366b;
}

/* Handle on hover */
.sign_up_card::-webkit-scrollbar-thumb:hover {
  background: #555;
}


`;
